import {isArrayNullUndefinedOrEmpty} from "../../../services/Validator";
import CoursesGradeBadgeItem from "../../items/courses/CoursesGradeBadgeItem";

export default function CoursesGradesList({  grades,
                                             selectedGrade,
                                             setFlashGrade,
                                             gradePickerSize }) {
    // Used in GradeMobileContent and LevelDesktopContent to
    // display list of flash levels to pick

    // BUILD
    if (isArrayNullUndefinedOrEmpty(grades))
        return null
    return (
        <div className={"w-full flex justify-center items-center"}>
            <div className={"w-[500px] flex justify-between items-center"}>
                {grades?.map((grade, index) => (
                    <CoursesGradeBadgeItem key={index}
                                           grade={grade}
                                           selectedGrade={selectedGrade}
                                           setFlashGrade={setFlashGrade}
                                           gradePickerSize={gradePickerSize}/>
                ))}
            </div>
        </div>
    );
}